export const UNSUBSCRIBE_NEWSLETTER = "UNSUBSCRIBE_NEWSLETTER";
export const RESET_UNSUBSCRIBE_NEWSLETTER = "RESET_UNSUBSCRIBE_NEWSLETTER";

export interface UnsubscribeNewsletter {
  type: typeof UNSUBSCRIBE_NEWSLETTER;
  payload: {
    email: string;
  };
}

export interface ResetUnsubscribeNewsletter {
  type: typeof RESET_UNSUBSCRIBE_NEWSLETTER;
  payload: null;
} 